import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdClass, MdEmail, MdInbox, MdMarkunreadMailbox, MdOutlineSettingsSuggest, MdSchool, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function TeacherDashboardPageMobile() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [teacherName, setTeacherName] = useState(() => {
        const nameNow = localStorage.getItem('name');
        return nameNow;
    });

    const [teacherDistrict, setTeacherDistrict] = useState(() => {
        const nameNow = localStorage.getItem('district');
        return nameNow;
    });

    const [teacherClass, setTeacherClass] = useState(() => {
        const nameNow = localStorage.getItem('assignedClass');
        return nameNow;
    });

    const [teacherSchool, setTeacherSchool] = useState(() => {
        const nameNow = localStorage.getItem('school');
        return nameNow;
    });

    const [loadingValues, setLoadingValues] = useState(false);

    const [rStudents, setRStudents] = useState(0);
    const [pStudents, setPStudents] = useState(0);

    useEffect(() => {
        localStorage.removeItem('studentEmailForResetPassword');
    }, []);

    useEffect(() => {
        if (teacherName !== "") {
            setLoadingValues(true);
            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };
            const apiUrl = `${web_url}/api/auth/teachers/structure?userRole=STUDENT`
            axios.get(apiUrl, configToken)
                .then((response) => {
                    const district = response.data.find((d) => d.district === teacherDistrict);
                    const school = district?.schools.find((s) => s.school === teacherSchool);
                    const teacher = school?.teachers.find((t) => t.teacherName === teacherName && t.assignedClass === teacherClass);

                    if (!teacher || !teacher.students) {
                        setRStudents(0);
                        setPStudents(0);
                        setLoadingValues(false);
                        return;
                    }

                    const pendingStudents = teacher.students.filter(student => student.accountStatus === "PENDING").length;
                    const notPendingStudents = teacher.students.filter(student => student.accountStatus !== "PENDING").length;
                    setRStudents(notPendingStudents);
                    setPStudents(pendingStudents);
                    setLoadingValues(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setRStudents(0);
                    setPStudents(0);
                });
        }
    }, [teacherName])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1270) {
                navigate('/desktop/teacher/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "teacher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] mr-[100px]  font-semibold text-[15px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>

            <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[30px] w-full">
                <div className="bg-[#FDC50C] rounded-2xl ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-[200px] md:w-[180px] flex justify-center">
                    <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t104')}</p>
                </div>
            </div>
            <div className="grid grid-cols-2 mt-[30px] ml-[20px] mr-[20px] md:ml-[60px] md:mr-[60px] lg:ml-[80px] lg:mr-[80px] xl:ml-[150px] xl:mr-[150px] 2xl:ml-[240px] 2xl:mr-[240px]">
                <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                    <div className="bg-[#DDC69D] w-full flex justify-center rounded-t-xl">
                        <p className="text-[#695531] text-[14px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t105')}</p>
                    </div>
                    <div className="bg-[#FEF2DC] w-full flex justify-center rounded-b-xl">
                        {
                            loadingValues ?
                                <div className="items-center justify-center flex p-3">
                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#A07B00] rounded-full animate-spin'></div>
                                </div> : <p className="text-[#A07B00] font-bold text-[40px] px-[20px] py-[10px]">{rStudents}</p>
                        }
                    </div>
                </div>
                <div className="flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                    <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl">
                        <p className="text-[#336C4B] text-[14px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t106')}</p>
                    </div>
                    <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                        {
                            loadingValues ?
                                <div className="items-center justify-center flex p-3">
                                    <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                </div> : <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{pStudents}</p>
                        }
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/teacher/managestudents')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSettings size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSettings size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t107')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/teacher/studentactivity')} >
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdClass size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdClass size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t108')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/mobile/teacher/mailbox/inbox')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdEmail size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdEmail size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t109')}</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home-y.svg" alt="home" onClick={() => navigate('/mobile/teacher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" alt="mail" onClick={() => navigate('/mobile/teacher/mailbox/inbox')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/teacher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/teacher/settings')} /></div>
            </div>
        </div>
    )
}

export default TeacherDashboardPageMobile;
